import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { getNeededTokensToRoll } from '../../../redux/Rules/selectors';
import Title from '../../baseComponents/Title';
import BaseButton from '../../baseButton';
import { SettingsActions } from '../../../redux/Settings';
import { RulesActions } from '../../../redux/Rules';
import colors from '../../../utils/colors';

const Container = styled.div`
  z-index: 2;
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Modal = styled.div`
  align-self: center;
  position: relative;
  padding-bottom: 24px;
  width: 60%;
  max-width: 650px;
  border: 2px solid ${colors.grey[3]};
  border-radius: 8px;
  background-color: ${colors.grey[1]};
  align-content: center;
  justify-content: center;
  text-align: center;
  color: ${colors.primaryText};
`;

const SmallTitle = styled.h4`
  font-size: 16px;
  margin-top: 30px;
`;

const ButtonContainer = styled.div`
  margin-top: 3em;
  display: flex;
  justify-content: space-evenly;
`;

const RolledRule = styled.button`
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #302220;
  border-radius: 4px;
  background-color: ${(props) =>
    props.selected ? colors.primary : colors.brown[0]};
  color: ${colors.primaryText};
  padding: 0.2em 2rem;
  min-height: 38px;
  font-size: 18px;
  margin: 20px auto 1em auto;
`;

const RuleRollModal = () => {
  const dispatch = useDispatch();
  const rollCost = useSelector((state) => getNeededTokensToRoll(state));
  const { rolledNewRules, ruleToRoll, selectedRule } = useSelector(
    (state) => state.rules,
  );
  const rollButtonText = 'Roll new rules (' + rollCost + ' tokens)';
  let newRules = [];
  newRules = rolledNewRules.map((rule) => {
    return (
      <RolledRule
        onClick={() => dispatch(RulesActions.setSelectedRule(rule))}
        key={rule.id}
        selected={selectedRule && rule.id === selectedRule.id}
      >
        {rule.ruleString}
      </RolledRule>
    );
  });
  return (
    <Container>
      <Modal>
        <Title text="Reroll a rule" />
        <SmallTitle>
          You can use collected tokens to reroll existing rules.
        </SmallTitle>
        <RolledRule
          onClick={() => dispatch(RulesActions.setSelectedRule(ruleToRoll))}
          key={ruleToRoll.rule.id}
          selected={selectedRule && selectedRule.id === ruleToRoll.rule.id}
        >
          {ruleToRoll.rule.ruleString}
        </RolledRule>
        {rolledNewRules.length > 0 ? (
          <div>
            {newRules}
            <BaseButton
              size="18"
              text="Select"
              onClick={() => dispatch(RulesActions.chooseSelectedRule())}
              disabled={selectedRule === null}
            />
          </div>
        ) : (
          <ButtonContainer>
            <BaseButton
              size="18"
              text={rollButtonText}
              onClick={() => dispatch(RulesActions.rollNewRules())}
            />
            <BaseButton
              size="18"
              text="Cancel"
              onClick={() =>
                dispatch(SettingsActions.setShowRuleRollModal(false))
              }
            />
          </ButtonContainer>
        )}
      </Modal>
    </Container>
  );
};

export default RuleRollModal;
